import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_53c9bebf-1df6-461a-ae92-22968598c10c/artifacts/xusxetuj_LOGO.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy text-cream" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4" data-testid="footer-logo">
              <img src={LOGO_URL} alt="521 Vending" className="h-20 w-20 object-contain" />
            </Link>
            <p className="text-cream/80 text-sm leading-relaxed">
              Curated refreshment amenities designed to elevate modern spaces.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-gold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/services/drink-machines"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-drink-machines"
                >
                  Drink Machines
                </Link>
              </li>
              <li>
                <Link
                  to="/services/snack-machines"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-snack-machines"
                >
                  Snack Machines
                </Link>
              </li>
              <li>
                <Link
                  to="/services/combo-machines"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-combo-machines"
                >
                  Combo Machines
                </Link>
              </li>
              <li>
                <Link
                  to="/services/micro-markets"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-micro-markets"
                >
                  Micro Markets
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-gold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/how-it-works"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-how-it-works"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-cream/80 hover:text-coral transition-colors"
                  data-testid="footer-contact"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-gold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-cream/80">
                <Phone className="h-4 w-4 text-coral" />
                <span>781-689-8537 (Call or Text)</span>
              </li>
              <li className="flex items-center gap-3 text-cream/80">
                <Mail className="h-4 w-4 text-coral" />
                <span>service@521vending.com</span>
              </li>
              <li className="flex items-start gap-3 text-cream/80">
                <MapPin className="h-4 w-4 text-coral mt-1" />
                <span>Serving Boston & the South Shore</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-cream/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-cream/60 text-sm">
              © {currentYear} 521 Vending. All rights reserved.
            </p>
            <p className="text-cream/60 text-sm font-mono">
              FRESH SNACKS • COLD DRINKS • HAPPY TEAMS
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
